export default __webpack_public_path__ + "static/media/AR-main.5776fbd5.jpg";